import { fetchWebsite } from '../utils/api/website.utils';
import { WebsiteState } from './website.types';

export type WebsiteConfiguration = {
  dataSources: any[];
  assets: any[];
  styles: any[];
  pages: any[];
  symbols: any[];
  totalPages: number;
};

export class UserWebsite {
  public id: string;
  public organizationId: string;
  public title: string;
  public description: string;
  public subdomain: string;
  public searchEngineVisibility: boolean;
  public lastPublishedAt: Date;
  public draft: WebsiteConfiguration;
  public published: WebsiteConfiguration;
  public formSubmissionSuccessMessage: string;

  constructor(params: {
    id: string;
    organizationId: string;
    title: string;
    description: string;
    subdomain: string;
    searchEngineVisibility?: boolean;
    lastPublishedAt?: Date;
    draft: WebsiteConfiguration;
    published: WebsiteConfiguration;
    formSubmissionSuccessMessage: string;
  }) {
    this.id = params.id;
    this.organizationId = params.organizationId;
    this.title = params.title;
    this.description = params.description;
    this.subdomain = params.subdomain;
    this.searchEngineVisibility = params.searchEngineVisibility ?? false;
    this.lastPublishedAt = params.lastPublishedAt ?? new Date();
    this.draft = params.draft;
    this.published = params.published;
    this.formSubmissionSuccessMessage = params.formSubmissionSuccessMessage;
  }

  isSearchEngineVisible(): boolean {
    return this.searchEngineVisibility;
  }

  getDraftConfiguration(): WebsiteConfiguration {
    return this.draft;
  }

  getPublishedConfiguration(): WebsiteConfiguration {
    return this.published;
  }

  static fromObject(obj: any): UserWebsite {
    return new UserWebsite({
      id: obj.id,
      organizationId: obj.organizationId,
      title: obj.title,
      description: obj.description,
      subdomain: obj.subdomain,
      searchEngineVisibility: obj.searchEngineVisibility,
      lastPublishedAt: new Date(obj.lastPublishedAt),
      draft: obj.draft,
      published: obj.published,
      formSubmissionSuccessMessage: obj.formSubmissionSuccessMessage,
    });
  }

  static async fromId(websiteId: string): Promise<UserWebsite> {
    return (await fetchWebsite(websiteId, 'user-website')) as UserWebsite;
  }

  toObject(): any {
    return {
      id: this.id,
      organizationId: this.organizationId,
      title: this.title,
      subdomain: this.subdomain,
      searchEngineVisibility: this.searchEngineVisibility,
      lastPublishedAt: this.lastPublishedAt.toISOString(),
      draft: this.draft,
      published: this.published,
      formSubmissionSuccessMessage: this.formSubmissionSuccessMessage,
    };
  }

  getHtml(websiteState: WebsiteState, pageIndex: number = 0): string {
    return this[websiteState ?? 'published']?.pages?.[pageIndex]?.html ?? '';
  }
}
